module.exports = __webpack_public_path__ + "static/media/sf_2600_gray.ed14163eb72b344063ee774594f0cf98.png";